/* tslint:disable */
/* eslint-disable */
// Generated by Microsoft Kiota
// @ts-ignore
import { createValidationProblemDetailsFromDiscriminatorValue, type ValidationProblemDetails } from '../../models/index.js';
// @ts-ignore
import { type BaseRequestBuilder, type Parsable, type ParsableFactory, type RequestConfiguration, type RequestInformation, type RequestsMetadata } from '@microsoft/kiota-abstractions';

/**
 * Builds and executes requests for operations under /Allotment/Approve
 */
export interface ApproveRequestBuilder extends BaseRequestBuilder<ApproveRequestBuilder> {
    /**
     * @param requestConfiguration Configuration for the request such as headers, query parameters, and middleware options.
     * @throws {ValidationProblemDetails} error when the service returns a 400 status code
     */
     post(requestConfiguration?: RequestConfiguration<ApproveRequestBuilderPostQueryParameters> | undefined) : Promise<void>;
    /**
     * @param requestConfiguration Configuration for the request such as headers, query parameters, and middleware options.
     * @returns {RequestInformation}
     */
     toPostRequestInformation(requestConfiguration?: RequestConfiguration<ApproveRequestBuilderPostQueryParameters> | undefined) : RequestInformation;
}
export interface ApproveRequestBuilderPostQueryParameters {
    id?: number;
    version?: number;
}
/**
 * Uri template for the request builder.
 */
export const ApproveRequestBuilderUriTemplate = "{+baseurl}/Allotment/Approve?id={id}&version={version}";
/**
 * Metadata for all the requests in the request builder.
 */
export const ApproveRequestBuilderRequestsMetadata: RequestsMetadata = {
    post: {
        uriTemplate: ApproveRequestBuilderUriTemplate,
        responseBodyContentType: "application/json",
        errorMappings: {
            400: createValidationProblemDetailsFromDiscriminatorValue as ParsableFactory<Parsable>,
        },
        adapterMethodName: "sendNoResponseContent",
    },
};
/* tslint:enable */
/* eslint-enable */
